import { combineReducers, configureStore } from '@reduxjs/toolkit';

import app from './app/slice';
import { ecomApi } from './ecomApi';
import payment from './payment/slice';

const rootReducer = combineReducers({
  app,
  payment,
  [ecomApi.reducerPath]: ecomApi.reducer,
});

const makeStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(ecomApi.middleware),
  });

const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
